var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.75C13.7812 12.75 16.5 10.0781 16.5 6.75C16.5 3.46875 13.7812 0.75 10.5 0.75C7.17188 0.75 4.5 3.46875 4.5 6.75C4.5 10.0781 7.17188 12.75 10.5 12.75ZM14.6719 14.25H13.875C12.8438 14.7656 11.7188 15 10.5 15C9.28125 15 8.10938 14.7656 7.07812 14.25H6.28125C2.8125 14.25 0 17.1094 0 20.5781V22.5C0 23.7656 0.984375 24.75 2.25 24.75H18.75C19.9688 24.75 21 23.7656 21 22.5V20.5781C21 17.1094 18.1406 14.25 14.6719 14.25Z",
    fill: "#2D5049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSelected);
export default __webpack_public_path__ + "static/media/user-selected.27f0a1c78438834739fb03e0da5e3a43.svg";
export { ForwardRef as ReactComponent };